import { render, staticRenderFns } from "./ProfileCardCalc.vue?vue&type=template&id=c29e8dba&scoped=true"
import script from "./ProfileCardCalc.vue?vue&type=script&lang=js"
export * from "./ProfileCardCalc.vue?vue&type=script&lang=js"
import style0 from "./ProfileCardCalc.vue?vue&type=style&index=0&id=c29e8dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29e8dba",
  null
  
)

export default component.exports